import { BASE_URL, CLIENTS, PLANS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IClient ,IClientInput} from "models/clients";


export async function getClients(params: string = "") : Promise<IClient[]> {
  const response = await axios.get(BASE_URL + CLIENTS + params);
  return response.data;
}
export async function addClient(data: IClientInput) {
  const response = await axios.post(BASE_URL + CLIENTS, data);
  return response.data;
}

export async function activityClient(id:number) {
  const response = await axios.post(BASE_URL + CLIENTS + '/ClientUpdateStatus' + `?clientId=${id}`);
  return response.data;
}

export async function editClient(data: IClientInput, id: string) {
  const response = await axios.patch(BASE_URL + CLIENTS + "/" + id , data);
  return response.data;
}

export async function deleteClient(id: string) {
  const response = await axios.delete(BASE_URL + CLIENTS + "/" + id);
  return response.data;
}

export const ClientsCells: HeadCell[] = [
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: "Client Name",
    
  },
  {
    id: "countryCode",
    numeric: false,
    disablePadding: false,
    label: "Country Code",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  
  {
    id: "resellerName",
    numeric: false,
    disablePadding: false,
    label: "Reseller",
  },
  {
    id: "isActive",
    numeric: false,
    disablePadding: false,
    label: "is Active",
  },

  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];



export const ClientsCellsNoActions: HeadCell[] = [
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: "Client",
    
  },
  {
    id: "serviceName",
    numeric: false,
    disablePadding: false,
    label: "Service",
    
  },
  {
    id: "planName",
    numeric: false,
    disablePadding: false,
    label: "Plan",
    
  },
  {
    id: "startDate",
    numeric: false,
    disablePadding: false,
    label: "Start Date",
    
  },
  {
    id: "renewalDate",
    numeric: false,
    disablePadding: false,
    label: "Renewal Date",
    
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
];
